// extracted by mini-css-extract-plugin
export default {"phoneLink":"textInfo-module__phoneLink--o0sep"};